<template>
  <section class="container-fluid white-box mb-4">
    <form>
      <form
        ref="form"
        class="d-flex justify-content-between align-items-center"
      >
        <div class="row promo-code-row">
          <div
            class="col-sm-12 d-flex justify-content-between align-items-center"
          >
            <input
              required
              v-model="promocode"
              class="flex-grow-1 form-control"
              type="text"
              id="promo-code"
              aria-describedby="PromoCode"
              placeholder="Promo Code"
            />
            <button
              class="promo-code"
              type="button"
              name="apply-promo"
              @click="apply"
            >
              Apply
            </button>
          </div>
        </div>
      </form>
    </form>
  </section>
</template>

<script>
// import axios from 'axios';
// import OrderReceipt from '@/components/HomeContainer.vue'
export default {
  name: "PromoCode",
  components: {},
  props: [],
  data() {
    return { promocode: undefined };
  },
  methods: {
    apply() {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.reportValidity();
        return;
      }
      this.$emit("apply-promo", this.promocode);
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
};
</script>

<style scoped>
.promo-code {
  color: #ff4f21;
  border: 2px solid #ff4f21;
  background-color: #fff;
  width: fit-content;
  margin-left: 6%;
  padding-left: 2vh !important;
  padding-right: 2vh !important;
}

.promo-code-row input,
.promo-code-row button {
}

.promo-code-row button {
  /* padding: 6px 0px !important; */
  /* font-size: 16px; */
  margin-right: 0px;
  /* height: 58px; */
  line-height: 0px;
}

.promo-code-row {
  margin-bottom: 0px;
  padding-bottom: 0px !important;
}
</style>
